const TRANSACTIONS_SORT_TYPES = {
  ASCENDING: 0,
  DESCENDING: 1,
};

const TRANSACTIONS_SORT_KEYS = {
  PROJECT_NAME: 0,
  ACTION: 1,
  TOKEN_COUNT: 2,
  USER_PUBLIC_ADDRESS: 3,
  TOKEN_ADDRESS: 4,
  TRANSACTION_HASH: 5,
  CREATE_DATE: 6,
  TRANSACTION_STATUS: 7,
};

const getTransactionDateSortValue = (transaction) =>
  transaction?.cdate || transaction?.transaction_time;

const sortTypes = [
  {
    name: 'Ascending',
    icon: 'BiSortUp',
  },
  {
    name: 'Descending',
    icon: 'BiSortDown',
  },
];

const sortKeys = [
  {
    name: 'Project Name',
    key: 'project_name',
    type: 'string',
    defaultSortType: TRANSACTIONS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Action',
    key: 'action',
    type: 'string',
    defaultSortType: TRANSACTIONS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Token Count',
    key: 'token_count',
    type: 'number',
    defaultSortType: TRANSACTIONS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'User Public Address',
    key: 'user_public_address',
    type: 'string',
    defaultSortType: TRANSACTIONS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Token Address',
    key: 'token_address',
    type: 'string',
    defaultSortType: TRANSACTIONS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Txn Hash',
    key: 'transaction_hash',
    type: 'string',
    defaultSortType: TRANSACTIONS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Txn Date',
    type: 'date',
    getValue: getTransactionDateSortValue,
    defaultSortType: TRANSACTIONS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Status',
    key: 'transaction_status',
    type: 'boolean',
    defaultSortType: TRANSACTIONS_SORT_TYPES.DESCENDING,
  },
];

const transactionsQuickFilterConstants = {
  ALL: 1,
  TRUE: 2,
  FALSE: 3,
};

export {
  TRANSACTIONS_SORT_KEYS,
  TRANSACTIONS_SORT_TYPES,
  sortTypes,
  sortKeys,
  transactionsQuickFilterConstants,
};
